import React from "react";
import client, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useFetch, PageHeader, Loading } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, RefreshCw, CheckCheck, AlertTriangle, FileWarning, Wallet } from "lucide-react";

const ICONS = { unpaid: Wallet, documents: FileWarning, announcement: Bell, default: AlertTriangle };

export default function Notifications() {
  const { data, loading, refetch } = useFetch("/notifications", []);

  const refresh = async () => { try { await client.post("/notifications/refresh"); toast.success("Alerts refreshed"); refetch(); } catch (e) { toast.error(apiError(e)); } };
  const readAll = async () => { await client.post("/notifications/read-all"); refetch(); };
  const readOne = async (id) => { await client.post(`/notifications/${id}/read`); refetch(); };

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Alerts for fees, documents and events" testid="notifications-page">
        <Button variant="outline" onClick={refresh} data-testid="notif-refresh"><RefreshCw size={16} className="me-1" /> Refresh Alerts</Button>
        <Button variant="outline" onClick={readAll} data-testid="notif-readall"><CheckCheck size={16} className="me-1" /> Mark all read</Button>
      </PageHeader>
      {loading ? <Loading /> : (data || []).length === 0 ? (
        <Card className="p-12 text-center text-muted-foreground">No notifications. Click "Refresh Alerts" to scan for unpaid fees and missing documents.</Card>
      ) : (
        <div className="space-y-3">
          {(data || []).map((n) => {
            const Icon = ICONS[n.type] || ICONS.default;
            return (
              <Card key={n.id} className={`p-4 flex items-start gap-4 ${!n.read ? "border-emerald-500/40 bg-emerald-500/5" : ""}`} data-testid={`notif-${n.id}`}>
                <div className="h-10 w-10 rounded-lg bg-emerald-500/10 text-emerald-600 flex items-center justify-center shrink-0"><Icon size={18} /></div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold">{n.title}</div>
                  <div className="text-sm text-muted-foreground">{n.message}</div>
                  <div className="text-xs text-muted-foreground mt-1">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
                </div>
                {!n.read && <Button size="sm" variant="ghost" onClick={() => readOne(n.id)}>Mark read</Button>}
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
